/**
 * User history API (`GET /history/user`).
 */

import apiClient from './api-client';
import type { UserHistoryDocument } from '@/types/history.types';

/** `GET /history/user?search=:userId` */
export const getUserHistory = async (userId: string): Promise<UserHistoryDocument> => {
  const { data } = await apiClient.get('/history/user', {
    params: { search: userId },
  });
  return data.data as UserHistoryDocument;
};
